import { format, isValid, startOfDay } from "date-fns";

// Debrief dates come back from the API as ISO strings, but older payloads may
// carry Firestore timestamps ({seconds} / {_seconds} / toDate()).
export const toDebriefDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (value.toDate) return value.toDate();
  if (value.seconds) return new Date(value.seconds * 1000);
  if (value._seconds) return new Date(value._seconds * 1000);
  const parsed = new Date(value);
  return isValid(parsed) ? parsed : null;
};

// A scheduled debrief is overdue once its scheduled day is over.
export const isDebriefOverdue = (debrief, now = new Date()) => {
  if (debrief?.status !== "scheduled") return false;
  const scheduled = toDebriefDate(debrief.scheduled_date);
  return !!scheduled && scheduled < startOfDay(now);
};

export const isDebriefUpcoming = (debrief, now = new Date()) => {
  if (debrief?.status !== "scheduled") return false;
  const scheduled = toDebriefDate(debrief.scheduled_date);
  return !!scheduled && scheduled >= startOfDay(now);
};

// "yyyy-MM-dd" in local time, the format of <input type="date">.
export const toDateInputValue = (value) => {
  const date = toDebriefDate(value);
  return date ? format(date, "yyyy-MM-dd") : "";
};

// Same convention as CreateDebriefModal: a date-only value is sent as ISO.
export const dateInputToISO = (value) => (value ? new Date(value).toISOString() : null);

export const isOperatorActive = (operator) => operator?.is_active !== false;
